module.exports = __webpack_public_path__ + "img/refresh.40d6b5ef.svg";